import { LABEL_GREY } from '../constants'

export const NONE_VALUE_SECTION_COLOR = LABEL_GREY
export const NONE_VALUE_SECTION_LABEL_COLOR = '#204060'
export const NONE_VALUE_SECTION_LABEL = '(Empty)'
